import React from 'react';

import Homepage from './Homepage';
import ProductPage from './ProductPage';
import ContactPage from './ContactPage';

import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    
    this.state= {
      currentLanguage: "EN",
      currentPage: "Home"
    }
  }
  
  switchLanguage() {
    let currentLanguage = this.state.currentLanguage === "EN" ? "ES" : "EN";
    this.setState({currentLanguage: currentLanguage});
  }
  
  switchPage(newPage) {
    console.log(newPage);
    this.setState({currentPage: newPage})
  }
  
  render() {
    let display;
    switch (this.state.currentPage) {
      case "Contact":
        display = <ContactPage language={this.state.currentLanguage}/>
        break;
      case "Product":
        display = <ProductPage language={this.state.currentLanguage}/>
        break;
      case "Home":
        //fallsthrough
      default:
        display = <Homepage language={this.state.currentLanguage}/>
    }
    
    return(
      <div>
        <nav className="siteNav">
          <div className="site-logo">
            <img
              src="./img/menetto.png"
              alt="Menetto Inc branding"
              onClick={() => this.switchPage("Home")}
              />
          </div>
          <div className="site-links">
            <p
              className="link"
              onClick={() => this.switchPage("Home")}
              >Home</p>
            <p
              className="link"
              onClick={() => this.switchPage("Product")}
              >Gallery</p>
            <p
              className="link"
              onClick={() => this.switchPage("Contact")}
              >Contact</p>
            <p
              className="link"
              onClick={() => this.switchLanguage()}
              id="switch"
              >{this.state.currentLanguage === "EN" ? "Spanish" : "English"}</p>
          </div>
        </nav>
        {display}
      </div>
    )
  }
}


export default App;


// WEBPACK FOOTER //
// ./src/App.js